<template id="">
  <div class="licenses-page">
    <div class="md-layout">
        <div>
          <md-dialog class='purchase-dialog' :md-active.sync="showPurchase">
            <PurchaseModal v-bind:purchaseType="purchaseType" v-on:closeModal="closeModal"/>
          </md-dialog>
        </div>
      <div class="md-layout-item md-size-100">
        <md-card>
          <md-card-header>
            <h3>Gold License</h3>
          </md-card-header>
          <md-card-content>
            <p class="license-info">
              SafeCore Certified Gold Level members are authorized to receive SafeCore-ATS “One-Call” Interior Locate Tracking Numbers as well as SafeCore- GPR/GIS Survey Reports for all SafeCore-ATS scan locations performed by a Certified SafeCore Technician. <br /><br/>

             Gold Level Members are allowed to “edit” the SafeCore-GPR/GIS Surveys by adding maintenance records, comments, images, drawings, spec sheets; videos as well as any other data directly associated to their SafeCore-ATS locations from any device. The SafeCore Survey Reports are created and delivered in real time utilizing GPS coordinates.
            </p>
            <div class="gold-options">
              <div>
                <p>Gold Level <b>Monthly</b> Subscription <br/> $99/Month</p>
                <md-button v-on:click="setShowPurchase('monthly')" class="md-info md-sm">Purchase Monthly License</md-button>
              </div>
              <div>
                <p>Gold Level <b>6-Month</b> Subscription <br/> Save $50 at $449 for 6 months</p>
                <md-button v-on:click="setShowPurchase('six')" class="md-info md-sm">Purchase 6 Month License</md-button>
              </div>
              <div>
                <p>Gold Level <b>Yearly</b> Subscription <br/> Save $200 at $999 for a year</p>
                <md-button v-on:click="setShowPurchase('year')" class="md-info md-sm">Purchase Yearly License</md-button>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
<!--      <div class="md-layout-item md-size-100">
        <md-card>
          <md-card-header>
            <h3>Silver License</h3>
          </md-card-header>
          <md-card-content>
            <div class="license-info">
              <p>
              SafeCore Certified Silver Level members are authorized to receive SafeCore-ATS “One-Call” Interior Locate Tracking Numbers as well as SafeCore-GPR/GIS Survey Reports for all SafeCore-ATS scan locations performed by a Certified SafeCore Technician. <br /> <br/>

              Choose the SafeCore Silver Edition:<br /> <br/>

              Receive your One Year SafeCore Silver Level Certification License and unlimited SafeCore-GPR-GIS Survey Reports: $100.00
             </p>
            <md-button v-on:click="setShowPurchase('silver')" class="md-info md-sm">Purchase Silver License</md-button>
            </div>
          </md-card-content>
        </md-card>
      </div> -->
      <div class="md-layout-item md-size-100">
        <md-card>
          <md-card-header>
            <h3>SafeCore Corporate</h3>
          </md-card-header>
          <md-card-content>
            <div class="license-info">
              <h3>Facility / Corporate Bundle Discounts</h3>
              <h6>Yearly Fees</h6>
              <p>5-9 Member Licneses: $4,900.00</p>
              <p>10-19 Member Licneses: $9,900.00</p>
              <p>20-49 Member Licneses: $14,900.00</p>
              <p>50+ Contact SafeCore for additional discounts</p>
              <h4>
                <b>Interested in purchasing SafeCore for your company to use? Click below!</b>
              </h4>

            <md-button href="mailto:jbutler@butlercoring.com" class="md-info md-lg">Learn More about SafeCore Corporate</md-button>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>
<script>
  import PurchaseModal from '@/pages/Dashboard/UserPages/Components/PurchaseModal';
  export default {
    components: {
      PurchaseModal
    },
    data(){
      return{
        showPurchase: false,
        purchaseType: null,

      }
    },
    mounted(){
      if (this.$store.getters.needsLicense){
        this.notifyVue('Your license has expired. Please purchase a license before proceeding into the tool', 'danger')
      }
    },
    methods: {
      setShowPurchase(type) {
        this.purchaseType = type;
        this.showPurchase = !this.showPurchase;
      },
      closeModal(){
        this.showPurchase = !this.showPurchase
      },
      notifyVue(message, color) {
        // var color = Math.floor(Math.random() * 4 + 1);
        this.$notify({
          // timeout: ,
          message: message,
          horizontalAlign: 'left',
          verticalAlign: 'top',
          type: color
        });
      },
    }
  }
</script>
<style media="screen" lang="scss">
  .licenses-page {
    .md-card-header {
      text-align: center;
      padding-bottom: 0;
    }
    .md-card-content {
      padding-top: 0px;
    }
    .license-info {
      text-align: center;
    }
    .gold-options {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      justify-content: center;
      div {
        text-align: center;
        width: 33%;
        p {
        }
      }
    }
    @media (max-width: 800px){
      .gold-options {
        flex-wrap: wrap;
        width: 100%;
        div {
          width: 100%;
        }
      }
    }
  }

</style>
